export const form_flow = [
  {
    'tag': 'cf-robot-message',
    'type': 'text',
    'name': 'welcome',
    'cf-questions': 'Bienvenue au service client Orange RDC !',
  },
];
